import type { KpiDelta } from '@platform/design-system';

type ChangeDirection = KpiDelta['direction'];

export type Change = { readonly amount: number; readonly direction: ChangeDirection };

const PERCENTAGE_POINTS = 100;

const directionOf = (amount: number): ChangeDirection => {
  if (amount > 0) return 'up';
  if (amount < 0) return 'down';
  return 'flat';
};

const changeOf = (amount: number): Change => ({ amount, direction: directionOf(amount) });

export const relativeChangeOf = (current: number, previous: number): Change | null =>
  previous === 0 ? null : changeOf((current - previous) / Math.abs(previous));

export const pointChangeOf = (current: number | null, previous: number | null): Change | null =>
  current === null || previous === null ? null : changeOf((current - previous) * PERCENTAGE_POINTS);
